export const NotificationScopes = [`api://${import.meta.env.VITE_NOTIFICATIONS_CLIENT_ID}/user_impersonation`]
export const NotificationBaseURL = import.meta.env.VITE_NOTIFICATIONS_ROOT
export const NotificationEndpoints = {
	notifications: '/notifications',
	notification: '/notification'
}
